import { useEffect } from "react";

const useKeyboard = (onMove) => {
  useEffect(() => {
    const handleKey = (e) => {
      const map = {
        ArrowLeft: "LEFT",
        ArrowRight: "RIGHT",
        ArrowUp: "UP",
        ArrowDown: "DOWN",
      };

      if (map[e.key]) {
        e.preventDefault();
        onMove(map[e.key]);
      }
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onMove]);
};

export default useKeyboard;
